// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3Bh69","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2H0BH"};